import { useEffect, useRef, useState } from "react";
import { getUsersByIds } from "../../../services/dataService";

// The users documents behind a tab's ids (teacher names). Each id is asked for once
// while the calling tab stays mounted — a missing or unreadable user is not retried and its row
// shows "-" (SessionsTable). A late answer still lands: this is a cache, not a page.
export const useUsersByIds = (ids) => {
  const asked = useRef(new Set());
  const [users, setUsers] = useState({});
  const key = [...new Set((ids || []).filter(Boolean))].filter((id) => !asked.current.has(id)).join(",");
  useEffect(() => {
    if (!key) return;
    const batch = key.split(",");
    batch.forEach((id) => asked.current.add(id));
    getUsersByIds(batch)
      .then((found) => setUsers((prev) => ({ ...prev, ...found })))
      .catch((e) => console.error("Error loading people:", e));
  }, [key]);
  return users;
};
